"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEMPLATE_RESET_PASSWORD_ADMIN = exports.TEMPLATE_RESET_PASSWORD = exports.TEMPLATE_INVITE_USER = exports.TEMPLATE_DELETE_REQUEST_TO_ADMIN = exports.TEMPLATE_DELETE_REQUEST_TO_USER_CONFIRMED = exports.TEMPLATE_DELETE_REQUEST_TO_USER = void 0;
exports.TEMPLATE_DELETE_REQUEST_TO_USER = 'deleteRequestToUser';
exports.TEMPLATE_DELETE_REQUEST_TO_USER_CONFIRMED = 'deleteRequestToUserConfirmed';
exports.TEMPLATE_DELETE_REQUEST_TO_ADMIN = 'deleteRequestToAdmin';
exports.TEMPLATE_INVITE_USER = 'inviteUser';
exports.TEMPLATE_RESET_PASSWORD = 'resetPassword';
exports.TEMPLATE_RESET_PASSWORD_ADMIN = 'resetPasswordAdmin';
//# sourceMappingURL=email.constants.js.map